
const despesacategoriaGridConfig = {
  idField: "idCategoriaDespesa",
  columns: [
  { header: "ID Categoria", field: "IDCATEGORIADESPESA" },
  { header: "Descrição", field: "DESCRICAO" },
  { header: "", field: "" }
]
};

export default despesacategoriaGridConfig;